
































import { Component, Prop, Vue } from 'vue-property-decorator';
import ExpandablePanel from '@/components/ExpandablePanel.vue';
import AddNodeButton from '@/components/buttons/AddNodeButton.vue';
import ButtonGrid from '@/components/buttons/ButtonGrid.vue';
import { CommonNodes } from '@/nodes/common/Types';
import { Getter, Mutation } from 'vuex-class';
import SearchBar from '@/SearchBar.vue';
import { ParsedFile } from '@/store/codeVault/types';
import { OverviewNodes } from '@/nodes/overview/Types';
import Scrollable from '@/components/wrappers/Scrollable.vue';
import Padded from '@/components/wrappers/Padded.vue';

@Component({
  components: {
    Scrollable,
    Padded,
    ExpandablePanel,
    AddNodeButton,
    ButtonGrid,
    SearchBar,
  },
})
export default class CustomTab extends Vue {
  @Prop({ default: CommonNodes.Custom }) customNode: string = OverviewNodes.Custom;
  private searchString = '';

  @Mutation('enterCodeVault') enterCodeVault!: () => void;
  @Mutation('closeFiles') closeFiles!: () => void;
  @Getter('files') files!: ParsedFile[];

  private search(search: string) {
    this.searchString = search;
  }

  private shouldRender(button: string) {
    return button.toLowerCase().includes(this.searchString.toLowerCase());
  }

  private get renderedFiles() {
    return this.files.map((file) => ({
      filename: file.filename,
      functions: file.functions.filter((func) => this.shouldRender(func.name)),
    }));
  }
}
